// extracted by mini-css-extract-plugin
export default {"container":"Page_container__l4Qt+","wrapper":"Page_wrapper__3I69h","content":"Page_content__XD+7U","column":"Page_column__XHIW-"};